/**
 * @file: Detector.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 农残检测仪配置
 */
import request from '@/utils/request'

/**
 * 新增农残检测信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectorAdd(data) {
  return request({
    type: 'device',
    url: 'detector/add',
    method: 'post',
    data
  })
}

/**
 * 删除农残检测信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectorDelete(data) {
  return request({
    type: 'device',
    url: 'detector/delete',
    method: 'post',
    data
  })
}

/**
 * 根据农残设备主键Id获取信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectorGet(data) {
  return request({
    type: 'device',
    url: 'detector/get',
    method: 'post',
    data
  })
}

/**
 * 根据条件获取农残检测信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectorListGet(data) {
  return request({
    type: 'device',
    url: 'detector/list/get',
    method: 'post',
    data
  })
}

/**
 * 更新农残检测信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function detectorUpdate(data) {
  return request({
    type: 'device',
    url: 'detector/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Detector.js